import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    communityId: "",
    userId: "",
    houseId: "",
    defOrgId: "",
    tenantId: "",
    openId: "",
    assetId: "",
  },
  mutations: {
    setCommunityId(state, communityId) {
      state.communityId = communityId;
    },
    setUserId(state, userId) {
      state.userId = userId;
    },
    setHouseId(state, houseId) {
      state.houseId = houseId;
    },
    setDefOrgId(state, defOrgId) {
      state.defOrgId = defOrgId;
    },
    setTenantId(state, tenantId) {
      state.tenantId = tenantId;
    },
    setOpenId(state, openId) {
      state.openId = openId;
    },
    setAssetId(state, assetId) {
      state.assetId = assetId;
    },
  },
  actions: {},
  modules: {},
});
